export const DISTANCE_FILTER = 'DISTANCE_FILTER';

type DistanceFilterState = {
    value: number;
    displayValue: string;
    selected: boolean;
    disabled: boolean;
};

export const updateDistanceFilter = (payload) => ({
    type: DISTANCE_FILTER,
    payload,
});

export default (state = [] as DistanceFilterState[], action): DistanceFilterState[] =>
    action.type === DISTANCE_FILTER ? action.payload || [] : state;
